import { faTrash } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, Modal } from '@orobix/orobix-fe-components'
import React from 'react'
import { useTranslation } from 'react-i18next'

export interface DeleteConfirmationModalProps {
  onCloseRequest: () => void
  onDeleteRequest: () => void
  message?: React.ReactNode
}

export const DeleteConfirmationModal = ({
  onCloseRequest,
  onDeleteRequest,
  message,
}: DeleteConfirmationModalProps) => {
  const { t } = useTranslation()

  return (
    <Modal
      size="sm"
      onCloseRequest={onCloseRequest}
      title={t('Confirm deletion')}
      footer={
        <>
          <Button
            onClick={onCloseRequest}
            label={t('Abort')}
            type="default"
            buttonType="button"
          />
          <Button
            data-testid="confirmDeleteProjectButton"
            onClick={() => {
              onCloseRequest()
              onDeleteRequest()
            }}
            icon={<FontAwesomeIcon icon={faTrash} />}
            label={t('Delete')}
            type="destroy"
            buttonType="button"
          />
        </>
      }
    >
      {message ??
        t(
          'Are you sure you want to delete this item? This action cannot be undone.'
        )}
    </Modal>
  )
}

export default DeleteConfirmationModal
